import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import {A11yModule} from '@angular/cdk/a11y';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {PortalModule} from '@angular/cdk/portal';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBadgeModule} from '@angular/material/badge';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import {OverlayModule} from '@angular/cdk/overlay';
import { AcessoComponent } from './acesso/acesso.component';
import { BannerComponent } from './acesso/banner/banner.component';
import { LoginComponent } from './acesso/login/login.component';
import { CadastroComponent } from './acesso/cadastro/cadastro.component';
import { Autenticacao } from './autenticacao.service';
import { HomeComponent } from './home/home.component'
import { RouterModule } from '@angular/router'
import { ROUTES } from './app.routes'



import { AutenticacaoGuard } from './autenticacao-guard.service';
import { LayoutModule } from '@angular/cdk/layout';
import { PainelControleComponent } from './painel-controle/painel-controle.component'
import { HttpClientModule } from '@angular/common/http';
import { UsuarioService } from './usuario.service';
import { CadastroOperacaoervice } from './acesso/cadastro-operacao/cadastro-operacao.service';
import { CadastroUsuarioService } from '../app/acesso/cadastro-usuario/cadastro-usuario.service';
import { MonitoriaService } from '../app/acesso/monitoria/monitoria.service';
import { CadastroFichaMonitoriaService } from '../app/acesso/cadastro-ficha-monitoria/cadastro-ficha-monitoria.service';

import { LogsService } from '../app/logs/logs.service';




import { StatusService } from './acesso/cadastro-ficha-monitoria/conteudo-global/status.service';
import { ProfileService } from './acesso/cadastro-ficha-monitoria/conteudo-global/profile.service';
import { ParecerPlanoDeAcaoService } from './acesso/parecer-plano-acao/parecer-plano-acao.service';




import { TabsComponent } from './acesso/tabs/tabs.component';
import { TabComponent } from './acesso/tabs/tab.component';
import { DynamicTabsDirective } from './acesso/tabs/dynamic-tabs.directive';
import { PersonEditComponent } from './acesso/people/person-edit.component';
import { PeopleListComponent } from './acesso/people/people-list.component';

import { FormsModule } from '@angular/forms';
import { MonitoriaComponent } from './acesso/monitoria/monitoria.component';
import { OperacaoComponent } from './acesso/operacao/operacao.component';
import { RelatorioComponent } from './acesso/relatorio/relatorio.component';
import { FichamonitoriaComponent } from './acesso/fichamonitoria/fichamonitoria.component';
import { CadastroFichaMonitoriaComponent, DialogPreviaFormulario, DialogDuplicarFormulario } from './acesso/cadastro-ficha-monitoria/cadastro-ficha-monitoria.component';
import { CadastroOperacaoComponent } from './acesso/cadastro-operacao/cadastro-operacao.component';
import { CadastroUsuarioComponent } from './acesso/cadastro-usuario/cadastro-usuario.component';
import { PermissaoUsuarioDialog } from './acesso/cadastro-usuario/cadastro-usuario.component';
import { EmpresaUsuarioDialog } from './acesso/cadastro-usuario/cadastro-usuario.component';
import { FormulariomonitoriaDialog } from './acesso/monitoria/monitoria.component';
import { ContestacaoMonitoriaDialog } from './acesso/monitoria/monitoria.component';
import { ComentarioMonitoriaDialog } from './acesso/monitoria/monitoria.component';
import { ObservacaoMonitoriaDialog } from './acesso/monitoria/monitoria.component';
import { RespostaComentarioDialog } from './acesso/monitoria/dialog-resposta-contestacao/dialog-resposta-contestacao';
import { ParametroMotivoDialogDialog, PrevParametroMotivoDialog } from './acesso/monitoria/parametro-motivo-dialog/parametro-motivo-dialog';






import {MAT_DATE_LOCALE} from '@angular/material/core';
import { StatusMonitoryService } from './acesso/monitoria/conteudo-global/status-monitory.service';
import { DatePipe } from '@angular/common';
import { FeedbackLoginDialogDialog } from './acesso/monitoria/feedback-login-dialog/feedback-login-dialog';
import { FeedbackLoginDialogService } from './acesso/monitoria/feedback-login-dialog/feedback-login-dialog.service';
import { ConfiguracaoService } from './acesso/configuracao/configuracao.service';
import { SpinnerComponent } from './acesso/spinner/spinner.component';
import { InterceptorModule } from './interceptors/interceptor.module';
import { ExclusaoMonitoriaDialogComponent } from './acesso/monitoria/exclusao-monitoria-dialog/exclusao-monitoria-dialog.component';
import { ExclusaoMonitoriaDialogService } from './acesso/monitoria/exclusao-monitoria-dialog/exclusao-monitoria-dialog.service';
import { ExclusaoMonitoriaPendenteComponent } from './acesso/exclusao-monitoria-pendente/exclusao-monitoria-pendente.component';
import { ExclusaoMonitoriaPendenteService } from './acesso/exclusao-monitoria-pendente/exclusao-monitoria-pendente.service';
import { ConfirmationDialogComponent } from './shared/components/confirmation-dialog/confirmation-dialog.component';
import { ParecerPlanoAcaoComponent } from './acesso/parecer-plano-acao/parecer-plano-acao.component';
import { LogsComponent } from './logs/logs.component';
import { AuthenticatorComponent } from './acesso/authenticator/authenticator.component';
import { AnexosDialogComponent } from './acesso/monitoria/anexos-dialog/anexos-dialog.component';




@NgModule({
  declarations: [
    AppComponent,
    AcessoComponent,
    BannerComponent,
    LoginComponent,
    CadastroComponent,
    HomeComponent,
    PainelControleComponent,
    TabsComponent,
    TabComponent,
    DynamicTabsDirective,
    PersonEditComponent,
    PeopleListComponent,
    MonitoriaComponent,
    OperacaoComponent,
    RelatorioComponent,
    FichamonitoriaComponent,
    CadastroFichaMonitoriaComponent,
    CadastroOperacaoComponent,
    CadastroUsuarioComponent,
    PermissaoUsuarioDialog,
    EmpresaUsuarioDialog,
    FormulariomonitoriaDialog,
    ContestacaoMonitoriaDialog,
    ComentarioMonitoriaDialog,
    ObservacaoMonitoriaDialog,
    FormulariomonitoriaDialog,
    FeedbackLoginDialogDialog,
    RespostaComentarioDialog,
    ParametroMotivoDialogDialog,
    PrevParametroMotivoDialog,
    SpinnerComponent,
    DialogPreviaFormulario,
    DialogDuplicarFormulario,
    ExclusaoMonitoriaDialogComponent,
    ExclusaoMonitoriaPendenteComponent,
    ConfirmationDialogComponent,
    ParecerPlanoAcaoComponent,
    LogsComponent,
    AuthenticatorComponent,
    AnexosDialogComponent


  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    A11yModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    OverlayModule,
    PortalModule,
    ScrollingModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    RouterModule.forRoot(ROUTES,  {useHash: true }),
    LayoutModule,
    HttpClientModule,
    InterceptorModule,
    FormsModule

  ],

  providers: [
              {provide: MatDialogRef, useValue: {} },
              {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
              Autenticacao,
              AutenticacaoGuard,
              UsuarioService,
              CadastroOperacaoervice,
              CadastroUsuarioService,
              MonitoriaService,
              CadastroFichaMonitoriaService,
              ProfileService,
              StatusService,
              StatusMonitoryService,
              DatePipe,
              FeedbackLoginDialogService,
              ConfiguracaoService,
              FormulariomonitoriaDialog,
              ExclusaoMonitoriaDialogService,
              ExclusaoMonitoriaPendenteService,
              MonitoriaComponent,
              ParecerPlanoDeAcaoService,
              LogsService
            ],
  exports: [ MatStepperModule ],

  bootstrap: [AppComponent]
})
export class AppModule { }
